import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  getMessages as onGetMessages,
  setMessagesTableData as onSetMessagesTableData,
  setMessagesPage as onSetMessagesPage,
  setCurrentMessageIndex as onSetCurrentMessageIndex,
  setMessagesTablePageData as onSetMessagesTablePageData,
  setMessagesTableScroll as onSetMessagesTableScroll
} from '../../actions/messagesActions'

const mapStateToProps = (state) => ({
  messagesDataState: state.messages.dataState,
  messagesCount: get(state, ['messages', 'count'], 0),
  messagesData: get(state, ['messages', 'data'], []),
  messagesErrors: get(state, ['messages', 'errors'], []),
  messagesTableData: get(state, ['messages', 'tableData'], []),
  messagesPage: get(state, ['messages', 'page'], 1),
  currentMessageIndex: get(state, ['messages', 'currentIndex'], 0),
  messagesTablePageData: get(state, ['messages', 'tablePageData'], {}),
  messagesTableScroll: get(state, ['messages', 'tableScroll'], 0)
})

const mapDispatchToProps = {
  onGetMessages,
  onSetMessagesTableData,
  onSetMessagesPage,
  onSetCurrentMessageIndex,
  onSetMessagesTablePageData,
  onSetMessagesTableScroll
}

const withMessages = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withMessages }